import * as React from "react"

import { GlassesRound } from "./round"
import { GlassesSquare } from "./square"

const _Glasses = ({
  style,
  isEditor
}: {
  style: string
  isEditor?: boolean
}) => {
  switch (style) {
    case "round":
      return <GlassesRound isEditor={isEditor} />
    case "square":
      return <GlassesSquare isEditor={isEditor} />
    case "none":
    default:
      return null
  }
}

export const Glasses = React.memo(_Glasses)
